import React from 'react';
import PropTypes from 'prop-types';
import authorizationShape from '../authorizationShape';
import AuthorizationHistoryLineItem from './AuthorizationHistoryLineItem';
import { formatAmount, formatDates } from '../utils';

const RequestedAuthorizationFields = ({ authorization, notesContent }) => (
  <>
    <AuthorizationHistoryLineItem field="Amount Requested">
      {formatAmount(authorization)}
    </AuthorizationHistoryLineItem>
    <AuthorizationHistoryLineItem field="Date(s) Requested">
      {formatDates(authorization)}
    </AuthorizationHistoryLineItem>
    <AuthorizationHistoryLineItem field="Request Note">
      {notesContent ? (
        <div className="whitespace-pre-line">{notesContent}</div>
      ) : (
        'N/A'
      )}
    </AuthorizationHistoryLineItem>
  </>
);

RequestedAuthorizationFields.propTypes = {
  authorization: PropTypes.shape(authorizationShape).isRequired,
  notesContent: PropTypes.string,
};

RequestedAuthorizationFields.defaultProps = {
  notesContent: null,
};

export default RequestedAuthorizationFields;
